import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from 'assets/img/position/locate.png';
import _imports_1 from 'assets/img/position/work.png';
import _imports_2 from 'assets/img/position/study.png';
import _imports_3 from 'assets/img/position/type.png';
import _imports_4 from 'assets/img/position/user.png';
const _withScopeId = n => (_pushScopeId("data-v-be5df0a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "position-detail"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "path"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "time"
};
const _hoisted_7 = {
  class: "info"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "全职", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_14 = {
  class: "detail"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "职位描述", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "任职要求", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "more",
  target: "_black",
  href: "https://company.zhaopin.com/CZ849328770.html"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "查看更多职位"), /*#__PURE__*/_createElementVNode("div", {
  class: "right"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, "首页 / 加入我们 / " + _toDisplayString($data.detail.positionName), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($data.detail.positionName), 1), _createElementVNode("div", _hoisted_6, "发布时间：" + _toDisplayString($data.detail.publishTime), 1), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", null, _toDisplayString($data.detail.address), 1), _hoisted_9, _createElementVNode("div", null, _toDisplayString($data.detail.experience), 1), _hoisted_10, _createElementVNode("div", null, _toDisplayString($data.detail.educationBackground), 1), _hoisted_11, _hoisted_12, _hoisted_13, _createElementVNode("div", null, _toDisplayString($data.detail.num), 1)])])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _hoisted_16, _createElementVNode("div", {
    class: "desc",
    innerHTML: $data.detail.describe
  }, null, 8, _hoisted_17), _hoisted_18, _hoisted_19, _createElementVNode("div", {
    class: "desc",
    innerHTML: $data.detail.require
  }, null, 8, _hoisted_20)]), _hoisted_21]);
}